import React from 'react';
import { Button } from '@/components/ui/button';
import { Menu, Plus, Bell, LogOut } from 'lucide-react';
import LanguageSelector from './LanguageSelector';
import { useLanguage } from '@/contexts/LanguageContext';

function Header({ user, onMenuClick, onCreateWorkOrder, onLogout }) {
  const { t } = useLanguage();
  
  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4 shadow-sm">
      <div className="flex items-center justify-between">
        {/* Left side - Mobile menu button and title */}
        <div className="flex items-center space-x-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={onMenuClick}
            className="lg:hidden h-8 w-8 p-0"
            data-testid="mobile-menu-btn"
          >
            <Menu className="h-4 w-4" />
          </Button>
          
          <div>
            <h1 className="text-2xl font-semibold text-gray-900">
              {t('dashboard')}
            </h1>
            <p className="text-sm text-gray-500">
              {t('dashboardSubtitle')}
            </p>
          </div>
        </div>

        {/* Right side - Language selector, User info and sign out */}
        <div className="flex items-center space-x-3">
          <LanguageSelector />
          <div className="text-right mr-2">
            <p className="text-sm font-medium text-gray-900">{user?.username || 'User'}</p>
            <p className="text-xs text-gray-500">{user?.email || ''}</p>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={onLogout}
            className="flex items-center gap-2 text-red-600 hover:text-red-700 hover:bg-red-50 border-red-200"
          >
            <LogOut className="h-4 w-4" />
            {t('signOut')}
          </Button>
        </div>
      </div>
    </header>
  );
}

export default Header;